TermInterceptor = ($q, $location, returnUrlAfterTerm) ->
  saveCurrentUrl = ->
    if $location.path() isnt '/term'
      returnUrlAfterTerm.url = $location.path()

  responseError: (rejection) ->
    switch rejection.status
      when 400
        if rejection.data?.code is 'error.term_not_accepted'
          saveCurrentUrl()
          # $location.path('/term')
    $q.reject rejection

TermInterceptor.$inject = [
  '$q'
  '$location'
  'returnUrlAfterTerm'
]

module.exports = TermInterceptor



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/term/term-interceptor.coffee